import { LoadingContext } from 'context/3cat/LoadingProvider';
import { useContext } from 'react';

export const useLoading = () => {
    const { setIsActiveLoading, activeLoading, activeLoadingLayout } = useContext(LoadingContext);

    return { setIsActiveLoading, activeLoading, activeLoadingLayout };
};
